export default __webpack_public_path__ + "static/media/launchpad1.ada2399e.svg";